<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2 class="font-weight-bolder">{{ $t('memberDataSection.greenCoffee.bulkImport.title') }}</h2>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined class="mr-2" @click="goBack">
          {{ $t('back') }}
        </v-btn>
      </div>

      <v-card elevation="0" class="px-5">
        <v-card elevation="0" class="green-coffee-bulk-tabs-card">
          <v-tabs
            v-model="tab"
            class="green-coffee-bulk-tabs"
            background-color="transparent"
            :grow="false"
          >
            <v-tab class="text-capitalize">{{ $t('oma.import') }}</v-tab>
            <v-tab class="text-capitalize">{{ $t('oma.history') }}</v-tab>
          </v-tabs>
        </v-card>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <GreenCoffeeBulkImportTab
              @cancelImport="goBack"
              @importSuccess="onImportSuccess"
            />
          </v-tab-item>
          <v-tab-item>
            <GreenCoffeeBulkImportHistory v-if="tab === 1" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import GreenCoffeeBulkImportTab from "./GreenCoffeeBulkImportTab.vue";
import GreenCoffeeBulkImportHistory from "./GreenCoffeeBulkImportHistory.vue";

export default {
  name: "GreenCoffeeBulkImport",
  components: { GreenCoffeeBulkImportTab, GreenCoffeeBulkImportHistory },
  data() {
    return {
      tab: 0,
      breadcrumbs: [
        { text: this.$t("dashboard"), disabled: false, to: { name: "AdminDashboard" }, exact: true },
        { text: this.$t("dashboardSection.cropOverview"), disabled: true, href: "#" },
        { text: this.$t("dashboardSection.greenCoffee"), disabled: false, to: { name: "GreenCoffee" }, exact: true },
        { text: this.$t("memberDataSection.greenCoffee.bulkImport.title"), disabled: true, href: "#" },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: "GreenCoffee" });
    },
    onImportSuccess(detail) {
      // The result page loads everything from the API using the id in the URL.
      if (detail && detail.bulkImportId != null) {
        this.$router.push({
          name: "GreenCoffeeBulkImportResult",
          params: { id: String(detail.bulkImportId) },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.green-coffee-bulk-tabs-card {
  border-bottom: 1px solid #e0e0e0;
}

.green-coffee-bulk-tabs {
  ::v-deep .v-tabs-bar {
    background-color: #fff !important;
  }

  ::v-deep .v-slide-group__content {
    justify-content: flex-start;
  }

  ::v-deep .v-tab {
    text-transform: none;
    letter-spacing: 0;
    min-width: 100px;
    max-width: none;
    color: #787878;
    background-color: transparent;
    font-weight: 400;
  }

  ::v-deep .v-tab--active {
    color: var(--primary-color, #944a00) !important;
    background-color: #eeeeee !important;
    font-weight: 600;
  }

  ::v-deep .v-tabs-slider {
    background-color: var(--primary-color, #944a00) !important;
    height: 2px;
  }
}
</style>
